<app-base-dialog sizeClass="size-12-25" [noPadding]="true" [useParentHeight]="true">
	<div class="container" #container>
		@if (options.huidigeGroepering) {
			<div class="element sorteren" [class.active]="menuSorterenLaatste()" (mouseenter)="openSortDialog()" (click)="openSortDialog()" #sorteren>
				<app-icon name="sorteren-oplopend" color="typography-5" size="small"></app-icon>
				<span>Sorteren</span>
				<app-icon name="chevron-right" color="typography-5" size="small"></app-icon>
			</div>
			@if (options.lockable) {
				<div class="element vastzetten" (click)="changeLockedColumn()">
					@if (isLocked()) {
						<app-icon name="un-pinned" size="small" color="typography-5"></app-icon>
						<span>Kolom losmaken</span>
					} @else {
						<app-icon name="pinned" color="typography-5" size="small"></app-icon>
						<span>Kolom vastzetten</span>
					}
				</div>
			}
			@if (options.deletable) {
				<div class="element delete" (click)="delete()">
					<app-icon name="delete" color="typography-5" size="small"></app-icon>
					<span>Verwijderen</span>
				</div>
			}
		}
		<app-groepering-list
			class="groeperingen"
			[class.borderTop]="options.huidigeGroepering"
			[groeperingCategorieen]="groeperingen()"
			(selected)="select($event)"
		>
		</app-groepering-list>
		@if (hasAlleGroeperingen()) {
			<div
				class="element allGroups borderTop"
				[class.active]="menuAlleGroeperingenLaatste()"
				(mouseenter)="openAlleGroeperingenDialog()"
				(click)="openAlleGroeperingenDialog()"
				#alleGroeperingen
			>
				<span>Alle groeperingen</span>
				<app-icon name="chevron-right" color="typography-5" size="small"></app-icon>
			</div>
		}
	</div>
</app-base-dialog>
